import { render, staticRenderFns } from "./UpdateStorage.vue?vue&type=template&id=5b0be228&"
import script from "./UpdateStorage.vue?vue&type=script&lang=js&"
export * from "./UpdateStorage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports